import React, { useEffect, useState, useContext } from "react";
import { FormattedMessage } from "react-intl";
import { AppContext } from "../utilities/context";
// import Styles from "../../public/assets/css/main.css";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Link } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
import logo from "../../public/assets/images/shopwizelogo.png";
// import Chat from "./Chat";
import AlertCustom from "./AlertCustom";

const chatsenseTheme = createTheme({
  status: {
    danger: "#e53e3e",
  },
  palette: {
    primary: {
      main: "#2D5F4F",
      darker: "#053e85",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#FF6B3D", // Terracota para botones de acción
    },
    neutral: {
      main: "#64748B",
      contrastText: "#fff",
    },
    background: {
      default: "#FDFDFD",
    },
  },
});

const drawerWidth = 240;

function UserMenu(props) {
  let navItems;
  navItems = [
    {
      label: "Home",
      link: "/",
      localeId: "app.header.home.label",
      public: true,
    },
    // {
    //   label: "Help",
    //   link: "/help",
    //   localeId: "app.header.help.label",
    //   public: true,
    // },
    // {
    //   label: "Pricing",
    //   link: "/pricing",
    //   localeId: "app.header.pricing.label",
    //   public: true,
    // },
  ];
  if (props.context && props.context.user) {
    navItems.push({
      label: "Account",
      link: "/account",
      localeId: "app.header.account.label",
      public: true,
    });
    navItems.push({
      label: "Shop",
      link: "/shop",
      localeId: "app.header.shop.label",
      public: true,
    });
    navItems.push({
      label: "Locations Position",
      link: "/locations-position",
      localeId: "app.header.floors.label",
      public: true,
    });
    navItems.push({
      label: "Products",
      link: "/products",
      localeId: "app.header.shop.products.label",
      public: true,
    });
    navItems.push({
      label: "Locations",
      link: "/locations",
      localeId: "app.header.locations.label",
      public: true,
    });
    navItems.push({
      label: "Orders",
      link: "/orders",
      localeId: "app.header.orders.label",
      public: true,
    });
    navItems.push({
      label: "Statuses",
      link: "/orders-by-status",
      localeId: "app.header.statuses.label",
      public: true,
    });
    navItems.push({
      label: "Categories",
      link: "/categories",
      localeId: "app.header.categories.label",
      public: true,
    });
    navItems.push({
      label: "Tags",
      link: "/tags",
      localeId: "app.header.tags.label",
      public: true,
    });
  } else {
    navItems.push({
      label: "Login",
      link: "/login",
      localeId: "app.header.login.label",
      public: true,
    });
  }
  return navItems.map((item) => (
    <Link key={item.label} to={item.link} className={"headerMenu"}>
      <FormattedMessage id={item.localeId} defaultMessage={item.label} />
    </Link>
  ));
}

function Preloader(props) {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={false}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

const Layout = ({ children }) => {
  const context = useContext(AppContext);
  useEffect(() => {
    if (context) {
      setTenantConfig(context.tenantConfig);
      document.title = context.tenantConfig.appName;
      console.log("Tenant Config:", context.tenantConfig);
    }
    console.log("Holanda");
  }, []); // The empty dependency array means this effect will only run once (equivalent to componentDidMount)

  const [mobileOpen, setMobileOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [tenantConfig, setTenantConfig] = useState(null);

  const container = undefined;

  const handleClose = () => {
    setMobileOpen(false);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLink = (location) => {
    window.location.href = location;
    this.handleClose();
  };

  const BreadcrumbsItems = () => {
    if (context.breadcrumbs) {
      return context.breadcrumbs.map((d, index) =>
        d.url ? (
          <Link key={index} to={d.url}>
            {d.label}
          </Link>
        ) : (
          <span key={index}>{d.label}</span>
        )
      );
    }
    return null;
  };

  const AlertItem = () => {
    if (context.alert) {
      return context.alert.map((d, index) => (
        <AlertCustom
          key={index}
          show={d.open}
          message={d.message}
          severity={d.severity}
          onClose={() => context.updateAlertState([{ open: false }])}
        />
      ));
    }
    return null;
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <img
        src={"assets/images/"+context.tenantConfig.appId+"/"+context.tenantConfig.appId+"-logo-512x512.png"}
        className="App-logo mrkPT1em"
        alt="logo"
        style={{ width: "40px" }}
      />
      <Typography variant="h6" sx={{ my: 2 }}>
        {context.tenantConfig ? context.tenantConfig.appName : "ReplyBOT"}
      </Typography>
      <Divider />
      <List className={"drawerListMenu"}>
        <UserMenu drawer={true} context={context} />
      </List>
    </Box>
  );

  return (
    <ThemeProvider theme={chatsenseTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Preloader />
        <AppBar component="nav" color="primary" sx={{ height: "64px" }}>
          <Toolbar sx={{ height: "64px" }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>
            <Link to={"/"}>
              <img src={"assets/images/"+context.tenantConfig.appId+"/"+context.tenantConfig.appId+"-logo-512x512.png"} className={"AppLogo"} alt="logo" />
            </Link>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, display: { xs: "block", sm: "block" } }}
            >
              {context.tenantConfig ? context.tenantConfig.appName : "ReplyBOT"}
            </Typography>
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
              <UserMenu context={context} />
            </Box>
          </Toolbar>
        </AppBar>
        <Box component="nav">
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
        </Box>
        <Container
          maxWidth={false}
          disableGutters={false}
          className={"mainContainer"}
        >
          <Breadcrumbs
            aria-label="breadcrumb"
            children={<BreadcrumbsItems />}
            className={"breadcrumbs"}
          />
          <AlertItem />
          <Box component="main">{children}</Box>
          {/* <Chat /> */}
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default Layout;
